export default "__VITE_ASSET__7767bugz__"